import { motion } from "framer-motion";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";
import IconHappy from "../../../ui-components/icon-happy/icon-happy";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import DemoNote from "../../../ui-components/demo-note/demo-note";
import { Size } from "../../../logic/enums.ts";
const WelcomeElement = () => {
  return (
    <motion.div
      id={"welcome-element"}
      initial={{ opacity: 0, translateY: 20 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 1, type: "spring", bounce: 0.5, delay: 0.2 }}
    >
      <div className={"flex flex-col gap-4 rounded-lg py-4 text-left "}>
        <div className="flex flex-row gap-4 items-center">
          <div
            id={"welcome-icon"}
            className={
              "flex items-center justify-center w-10 h-10 rounded-md bg-color-raindrop-primary"
            }
          >
            {<IconHappy className="w-8 h-8 fill-white opacity-50" />}
          </div>

          <div className="text-3xl font-bold">Welcome to Raindrop</div>
        </div>

        <RaindropDivider />
        <div
          id={"no-organisations-home-text"}
          className="flex flex-col gap-4 opacity-70"
        >
          <div>
            We want to make it simple to support causes that matter to you, and
            to all of us
          </div>
          <div className="font-bold">
            No clipboards, no forms, no guilt, no lock-in, no unwanted emails,
            no hidden-costs, no pressure
          </div>
          <div>
            You'll pay one monthly payment and decide how you would like that
            distributed at any time
          </div>
          <div>You can pause your support at any time</div>
        </div>
      </div>
      <DemoNote
        text={
          "This pre-alpha build is still heavily under development.  Expect some things to be wonky and odd in all the weird and wonderful ways of early-stage software."
        }
      />
    </motion.div>
  );
};

const RaindropWelcome = () => {
  console.log("🟢 (RD-890) - ", "here");
  return (
    <div className={"flex flex-col h-full  gap-24 justify-center items-center"}>
      <WelcomeElement />

      <RaindropButton
        title={"Continue"}
        to={"/raindrop/kindness"}
        style={ButtonStyle.Primary}
        size={Size.Large}
      />
    </div>
  );
};

export default RaindropWelcome;
